import { css, html } from 'lit'
import { customElement } from 'lit/decorators.js'
import './skeleton'
import { SkeletonPreset } from './skeleton-preset'

/** Renders `count` metric blocks (number bar + label bar) in a horizontal strip. */
@customElement('schmancy-skeleton-stats')
export class SchmancySkeletonStats extends SkeletonPreset {
	static styles = [
		css`
			:host {
				display: flex;
				align-items: center;
				gap: 0.75rem;
			}
			.metric {
				display: flex;
				flex-direction: column;
				gap: 0.25rem;
			}
		`,
	]

	render() {
		return html`${Array.from(
			{ length: this.count },
			() =>
				html`<div class="metric">
					<schmancy-skeleton class="h-7 w-7 rounded-lg"></schmancy-skeleton>
					<schmancy-skeleton class="h-3 w-12 rounded-xs"></schmancy-skeleton>
				</div>`,
		)}`
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'schmancy-skeleton-stats': SchmancySkeletonStats
	}
}
